<template>
  <div class="wrapper">
    <Con1></Con1>
    <Con2></Con2>
    <Con3></Con3>
    <Con4></Con4>
    <Con5></Con5>
    <Con6></Con6>
    <Con7></Con7>
    <Con8></Con8>
    <Con9></Con9>
    <Con10></Con10>
  </div>
</template>
<script>
import Con1 from "@/components/AiTutorPlus/con1.vue";
import Con2 from "@/components/AiTutorPlus/con2.vue";
import Con3 from "@/components/AiTutorPlus/con3.vue";
import Con4 from "@/components/AiTutorPlus/con4.vue";
import Con5 from "@/components/AiTutorPlus/con5.vue";
import Con6 from "@/components/AiTutorPlus/con6.vue";
import Con7 from "@/components/AiTutorPlus/con7.vue";
import Con8 from "@/components/AiTutorPlus/con8.vue";
import Con9 from "@/components/AiTutorPlus/con9.vue";
import Con10 from "@/components/AiTutorPlus/con10.vue";

export default {
  components: { Con1, Con2, Con3, Con4, Con5, Con6, Con7, Con8, Con9, Con10 },
};
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

.wrapper {
  font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-use-select: none;
  user-select: none;
}
</style>
